
$(document).ready(function() {





  // const buttons = document.querySelectorAll('.tab-buttonps');

  //   buttons.forEach(button => {
  //     button.addEventListener('click', () => {
  //       // Remove 'active' class from all buttons
  //       buttons.forEach(btn => btn.classList.remove('active'));
  //       // Add 'active' class to clicked button
  //       button.classList.add('active');
  //     });
  //   });





  

    $(window).on('scroll', function () {
      var scrollTop = $(this).scrollTop();
      if(scrollTop > 130) {
        $('.aa-Panel').remove();
      }
    });
  
    $('.cstm-btn-color-liquid.search__button').click(function() {
      $('.search .aa-Form .aa-SubmitButton').click();
    });

    var subMenuSummary = $('.menu-drawer__submenu summary.menu-drawer__menu-item').length;
    for (var i = 0; i < subMenuSummary; i++) {
      $('.menu-drawer__submenu summary.menu-drawer__menu-item')[i].click();
    }

  function initTabsSlider() {
    const $tabsContainer = $('.coll-tabs-inner .tabs-container-inner');
  
    if (!$tabsContainer.length) return;
  
    if (window.innerWidth < 1050) {
      if (!$tabsContainer.hasClass('slick-initialized')) {
        $('.coll-tabs-inner .cstm_slider').remove();
        $tabsContainer.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"> <circle cx="17" cy="17" r="17" transform="rotate(-180 17 17)" fill="#F8F8F8"/> <path d="M18.275 22.9495L12.325 16.9995L18.275 11.0495" stroke="#666666" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
          nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"> <circle cx="17" cy="17" r="17" fill="#F8F8F8"/> <path d="M15.725 11.0505L21.675 17.0005L15.725 22.9505" stroke="#666666" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>'
        });
  
        $tabsContainer.on('afterChange', function(event, slick, currentSlide){
          $(`.coll-tabs-inner .tabs-container-inner .tab-button[data-index="${currentSlide+1}"]`).click();
        });
  
        setTimeout(function() {
          $('.coll-tabs-inner .tabs-container-inner .tab-button.slick-active[data-index="1"]').click();
        }, 1000);
      }
      if($('.cstm_banner_mob .cstm_banner_boxes')) {
        $('.cstm_banner_mob .cstm_banner_boxes').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000
          });
      }
    } else {
      if ($tabsContainer.hasClass('slick-initialized')) {
        $tabsContainer.slick('unslick');
      }
      if ($('.cstm_banner_mob .cstm_banner_boxes').hasClass('slick-initialized')) {
        $('.cstm_banner_mob .cstm_banner_boxes').slick('unslick');
      }
    }
  }

  initTabsSlider();
  $(window).on('resize', function() {
    initTabsSlider();
  });
  
  if($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {

     $('.cstm_filter_coll_close').click(function () {
       $('.mobile-facets__close').click();
     });

    $('.cstm_readMore_btn').click(function(event) {
      event.preventDefault();
      $('.cstm_coll_desc_truncate').hide();
      $('.cstm_coll_desc_full').show();
    });

    $('.cstm_collapse_btn').click(function(event) {
      event.preventDefault();
      $('.cstm_coll_desc_truncate').show();
      $('.cstm_coll_desc_full').hide();
    });
    
  }

  function multiRowSlick() {
    const $slider = $('.AboutUs .multirow__inner');
    
    if (window.innerWidth < 550) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          adaptiveHeight: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        });
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  // Call once on load
  multiRowSlick();

  // Call again on resize
  window.addEventListener("resize", multiRowSlick);


  $('.cstm-box-contai .view-more a').click(function(e) {
    e.preventDefault();
    if($(this).hasClass('view-less')) {
      $(this).removeClass('view-less');
      $('.cstm_more_view').addClass('cstm_hide');
      $(this).html('view more <img src="https://cdn.shopify.com/s/files/1/0629/3402/4343/files/Rectangle_2811_1.svg?v=1708415796" />');
    } else {
      $(this).addClass('view-less');
      $('.cstm_more_view').removeClass('cstm_hide');
      $(this).html('view less <img src="https://cdn.shopify.com/s/files/1/0629/3402/4343/files/Rectangle_2811.svg?v=1708415796" />');
    }
  });

  if($('body').hasClass('template-customers-login')) {

     $('.cstm-sign-div a').click(function (e) {
       e.preventDefault();
       $('.cstm_login_wrapper').removeClass('active');
       $('.cstm_reset_password').addClass('active');
     });

     $('.cancel-submuit-btn').click(function (e) {
       e.preventDefault();
       $('.cstm_reset_password').removeClass('active');
       $('.cstm_login_wrapper').addClass('active');
     });
    
  }



  if($('body').hasClass('template-product') && !$('body').hasClass('legacy-product-template')) {

    // 1. CORE FUNCTION: Check for sold out / disabled statuses
    function checkDisabledOptions() {
        let hasDisabledOption = false;
        
        if($('.product-form__input input[type="radio"]').length > 0) {
          $('.product-form__input input[type="radio"]:checked').each(function() {
              if ($(this).closest('.disabled').length) {
                  hasDisabledOption = true;
                  $('.cstm_ofs').remove();
                  $('.product__text').after('<span class="mbl_sold_out_badg cstm_ofs"> Sold Out </span>');
                  $('.mbl_main_title_sec > h2').before('<span class="mbl_sold_out_badg cstm_ofs"> Sold Out </span>');
                  return false; 
              }
          });
        } else {
          if ($('.product-form__submit').is(':disabled')) {
              hasDisabledOption = true;
          }
        }
        
        if (hasDisabledOption) {
          $('.product-form__submit').attr("disabled", "disabled");
          $('.product-form__submit span').text('Sold out');
          $('.template-product .product__info-container.product__column-sticky .product-form__input.product-form__quantity').hide();
          $('.custom_btn_buy').hide();
          $('.cstm_notify_me').show();
        } else {
          $('.product-form__submit').removeAttr("disabled");
          $('.product-form__submit span').text('Add to cart');
          $('.template-product .product__info-container.product__column-sticky .product-form__input.product-form__quantity').show();
          $('.custom_btn_buy').show();
          $('.cstm_notify_me').hide();
          $('.cstm_ofs').remove();
        }
    }

    // 2. CORE FUNCTION: Safely injects the variant name into the label title
    function updateVariantLabels() {
      $('.product-form__input input[type="radio"]:checked').each(function() {
        var $container = $(this).closest('.product-form__input');
        var $legend = $container.find('legend.form__label');
        
        if ($legend.length) {
          $legend.find('.cstm_clknm').remove(); // Clear previous custom span if it exists
          
          var baseText = $legend.text().trim();
          var clickColor = $(this).attr('value');
          
          $legend.html(`${baseText}<span class="cstm_clknm">&nbsp;&nbsp;&nbsp;&nbsp;${clickColor}</span>`);
        }
      });
    }

    // 3. CORE FUNCTION: Dynamically updates desktop and mobile pricing, and the
    //    SKU
    //
    // The desktop price inside #price-<section-id> is swapped by Dawn itself,
    // now that the Liquid renders selected_variant. This function exists for
    // the elements that sit OUTSIDE that container and so are never swapped:
    // the mobile price, the sale badge, and both .cstm_prd_sku spans.
    //
    // Resolving the variant, most reliable first:
    //   1. the object Dawn hands us on PUB_SUB_EVENTS.variantChange
    //   2. <script data-selected-variant> inside <variant-selects>, which Dawn
    //      15 re-renders on every change
    //   3. ?variant= looked up in a full variants array -- the Dawn 13 shape,
    //      still emitted by the SellersDash picker path further down the snippet
    //
    // Step 2 is what broke on the Dawn 15 cutover: the old code took the FIRST
    // application/json script inside <variant-selects>, which used to be the
    // whole variants array and is now a single variant object. Object.values()
    // of that object yields its property values, so the id lookup could never
    // match and the price silently stopped updating.
    function resolveVariant(variant) {
      if (variant && variant.id) return variant;

      var selectedTag = document.querySelector('variant-selects script[data-selected-variant]');
      if (selectedTag) {
        try {
          var selected = JSON.parse(selectedTag.textContent);
          if (selected && selected.id) return selected;
        } catch (e) { /* fall through to the legacy shape */ }
      }

      var variantId = new URLSearchParams(window.location.search).get('variant');
      if (!variantId) return null;

      var scriptTag =
        document.querySelector('variant-selects script[type="application/json"]:not([data-selected-variant])') ||
        document.querySelector('variant-radios script[type="application/json"]');
      if (!scriptTag) return null;

      try {
        var rawData = JSON.parse(scriptTag.textContent);
        var variantsArray = Array.isArray(rawData)
          ? rawData
          : (rawData && Array.isArray(rawData.variants) ? rawData.variants : []);
        return variantsArray.find(function (v) {
          return v && v.id === parseInt(variantId, 10);
        }) || null;
      } catch (e) {
        return null;
      }
    }

    function money(cents) {
      return (cents / 100).toLocaleString("en-US", {
        style: "currency",
        currency: Shopify.currency.active
      });
    }

    function updatePriceAndBadges(variant) {
      var matchingVariant = resolveVariant(variant);
      if (!matchingVariant) return;

      var onSale = matchingVariant.compare_at_price > matchingVariant.price;
      var formattedPrice = money(matchingVariant.price);
      // compare_at_price is null off sale; formatting that gives "$0.00", so
      // blank it instead -- the element is hidden either way, but a stale
      // "$0.00" shows up if CSS ever fails to load.
      var formattedComPrice = matchingVariant.compare_at_price ? money(matchingVariant.compare_at_price) : '';

      $('.cstm_prd_price_wrapper .cstm_normal_price').text(formattedPrice);
      $('.cstm_prd_price_wrapper .cstm_cut_price').text(formattedComPrice);
      $('.product-price-mbl-real').text(formattedPrice);
      $('.product-price-mbl-compare-at').text(formattedComPrice);

      // The SKU. Dawn only swaps #Sku-<section-id>, the stock 'sku' block, which
      // this product template does not use -- the SKU on screen is the pair of
      // .cstm_prd_sku spans (mobile title, desktop title) and neither carries an
      // id, so nothing Dawn does touches them. Under Dawn 13 they were written by
      // custom code inside VariantSelects.onVariantChange in global.js; Dawn 15
      // moved variant handling to product-info.js and that class went with it,
      // taking the SKU update. Same cutover, same shape of break as the price.
      $('.cstm_prd_sku').text('SKU: ' + (matchingVariant.sku || ''));

      $('.cstm_prd_price_wrapper .cstm_normal_price').toggleClass('cstm_green', onSale);
      $('.cstm_prd_price_wrapper .cstm_cut_price').toggleClass('cstm_hide', !onSale);
      $('.product-price-mbl-compare-at').toggleClass('cstm_hide', !onSale);
      $('.cstm_sale_badge').toggleClass('cstm_hide', !onSale);
    }

    // Item 141, 2026-09-09. A history.replaceState/pushState monkeypatch with a
    // 600ms timer lived here as a "fallback" for the variant change. It was a
    // Dawn 13 guess at an event Dawn 15 publishes for real (below), and every
    // app or Dawn feature that called replaceState paid for it.

    // Dawn 15 publishes variantChange at the end of its own update, with the
    // variant object attached -- no lookup and no timing guess. The sibling-
    // product swap replaces <main> and re-renders everything server-side, so
    // it needs no client-side follow-up.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        updateVariantLabels();
        checkDisabledOptions();
        updatePriceAndBadges(event && event.data && event.data.variant);
      });
    }

    // 4. INITIAL RUN ON PAGE LOAD
    checkDisabledOptions();
    updateVariantLabels();
    updatePriceAndBadges();

    // 5. DELEGATED HOVER EVENTS
    $(document).on('mouseenter', '.product-form__input .cstm_var_sel_wrapper', function() {
      if ($(this).hasClass('disabled')) { $(this).addClass('cstm_notAvailable'); }
      $(this).addClass('cstm_colorHover');
    });

    $(document).on('mouseleave', '.product-form__input .cstm_var_sel_wrapper', function() {
      if ($(this).hasClass('disabled')) { $(this).removeClass('cstm_notAvailable'); }
      $(this).removeClass('cstm_colorHover');
    });

    // 6. DELEGATED CLICK EVENT (Instant local feedback for accordions/tooltips)
    $(document).on('click', '.product-form__input input[type="radio"]', function() {
      // Provide immediate feedback to the label text on click, before the 600ms slug listener triggers
      // updateVariantLabels();

      $('.ps-accordion-item').removeClass('selected');
      $('.ps-accordion-item .ps-icon-button').html('<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11 2V20" stroke="white" stroke-width="3" stroke-linecap="round"/> <path d="M20 11L2 11" stroke="white" stroke-width="3" stroke-linecap="round"/> </svg>');
      $('.ps-accordion-item .ps-icon-button').removeClass('minus');
      $('.ps-accordion-item .ps-icon-button').addClass('plus');
      $('.ps-accordion-content').hide();

      var rect = this.getBoundingClientRect();
      var tooltipWidth = 256;
      
      if (rect.left < 0) {
          $(this).parent().css('--tooltip-left', '10px');
      } else if (rect.right + tooltipWidth > $(window).width()) {
          $(this).parent().css('--tooltip-left', ($(window).width() - rect.right - 280) + 'px');
      } else {
          $(this).parent().css('--tooltip-left', '50%');
      }
    });

    $('.ps-accordion-header').click(function() {
      var totalVar = $(this).parent().find('.cstm_recommended_accessories_variants option').length;
      if($(this).find('.ps-icon-button').hasClass('plus')) {
        $(this).find('.ps-icon-button').html('<svg width="22" height="4" viewBox="0 0 22 4" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M20 2L2 2" stroke="#666666" stroke-width="3" stroke-linecap="round"/> </svg>');
        $(this).find('.ps-icon-button').removeClass('plus');
        $(this).find('.ps-icon-button').addClass('minus');
        $(this).parent().find('.ps-accordion-content').show();
        var selectedVal = $(this).parent().find('.cstm_recommended_accessories_variants').val();
        $(this).find('.ps-icon-button').attr('data-variant-id', selectedVal);
        $(this).parent().addClass('selected');
      } else {
        $(this).find('.ps-icon-button').html('<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11 2V20" stroke="white" stroke-width="3" stroke-linecap="round"/> <path d="M20 11L2 11" stroke="white" stroke-width="3" stroke-linecap="round"/> </svg>');
        $(this).find('.ps-icon-button').removeClass('minus');
        $(this).find('.ps-icon-button').addClass('plus');
        $(this).parent().find('.ps-accordion-content').hide();
        var selectedVal = $(this).parent().find('.cstm_recommended_accessories_variants').val();
        $(this).find('.ps-icon-button').attr('data-variant-id', '');
        $(this).parent().removeClass('selected');
        $(this).parent().removeClass('success');
      }
      var totalSelected = $('.ps-accordion-item.selected').length;
      if(totalSelected >= 1) {
        if($('.product-form__submit').is(':disabled')) {
          $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`(${totalSelected+1}) Sold out`);
        } else {
          $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`(${totalSelected+1}) Add to cart`);
        }
      } else {
        if($('.product-form__submit').is(':disabled')) {
          $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`Sold out`);
        } else {
          $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`Add to cart`);
        }
      }
      
    }); 

    $('.ps-product-options select').change(function() {
      // Find the parent accordion item container reliably
      var $accordionItem = $(this).closest('.ps-accordion-item');
      
      // Find all option dropdowns inside this specific accordion item
      var selectElements = $accordionItem.find('.ps-product-options select');
      var valuesArray = [];
      
      selectElements.each(function() {
          valuesArray.push($(this).val());
      });
      
      var concatenatedValues = valuesArray.join(' / ');
      
      // Find the matching master option, using .trim() to wipe out HTML spaces/newlines
      var matchingOption = $accordionItem.find(".cstm_recommended_accessories_variants option").filter(function() {
          return $.trim($(this).text()) === concatenatedValues;
      });

      // Check if a match was found
      if (matchingOption.length) {
          if (matchingOption.prop('disabled')) {
              $accordionItem.find('.cstm_error').remove();
              $accordionItem.append('<div class="cstm_error">This variant option is out of stock. Please select another one.</div>');
          } else {
              // 1. Select the option in the hidden master dropdown
              matchingOption.prop('selected', true);
              
              // 2. Clear any lingering error messages
              $accordionItem.find('.cstm_error').remove();
              
              // 3. Fetch the newly selected variant ID
              var selectedVal = $accordionItem.find(".cstm_recommended_accessories_variants").val();
              
              // 4. Update the button data attribute
              $accordionItem.find(".ps-icon-button").attr('data-variant-id', selectedVal);
          }
      } else {
      }
    });


    $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit').click(function(event) {
      if($('.ps-accordion-container').length >= 1) {
        
        if($('.ps-accordion-item.success').length >= 1) {
          $('.ps-accordion-item.success').removeClass('success');
        } else if($('.ps-accordion-item.selected:not(.success)').length >= 1) {
          event.preventDefault();
          var variantIds = [];
          $('.ps-accordion-item.selected .ps-icon-button').each(function() {
            var variantId = $(this).attr('data-variant-id');
            if ($.inArray(variantId, variantIds) === -1) {
              variantIds.push(variantId);
            }
          });
          var items = variantIds.map(function(variantId) {
            return {
              quantity: 1,
              id: variantId
            };
          });
          $.post('/cart/add.js', {
            items: items
          })
          .done(function(response) {
            $('.ps-accordion-item.selected').addClass('success');
            $('.ps-accordion-item').removeClass('selected');
            $('.ps-accordion-item .ps-icon-button').html('<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11 2V20" stroke="white" stroke-width="3" stroke-linecap="round"/> <path d="M20 11L2 11" stroke="white" stroke-width="3" stroke-linecap="round"/> </svg>');
            $('.ps-accordion-item .ps-icon-button').removeClass('minus');
            $('.ps-accordion-item .ps-icon-button').addClass('plus');
            $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`Add to Cart`);
            $('.ps-accordion-content').hide();
            setTimeout(function() {
              $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit').click();
            }, 1500);
          })
          .fail(function(error) {
            console.error('Error:', error);
          });
        } else {
          
        }
      }
    });

    // Item 15. Bound once and delegated, for the same reason as the toggle:
    // the arrows are inside a modal that is destroyed and rebuilt when a Body
    // Color change swaps the product.
    //
    // Dawn's ModalDialog closes a .media-modal on ANY mouse pointerup whose
    // target is not inside deferred-media or product-model (global.js:609) —
    // the rule behind its cursor:zoom-out. These arrows are plain divs inside
    // that zone, so a click on one closed the lightbox before slickGoTo could
    // run: the arrows had never worked. Stopping the pointer events keeps the
    // fix in our own file rather than patching a stock Dawn asset.
    function stopArrowPointer() {
      $('.cstm_arrow')
        .off('pointerdown.lb pointerup.lb')
        .on('pointerdown.lb pointerup.lb', function(event) { event.stopPropagation(); });
    }

    var lightboxArrowsBound = false;
    function bindLightboxArrows(go) {
      window.__lightboxGo = go;
      if (lightboxArrowsBound) return;
      lightboxArrowsBound = true;
      // NOT delegated, and this one cannot be: a delegated handler runs when the
      // event reaches `document`, by which point it has already bubbled through
      // <product-modal> and Dawn has closed the lightbox. The stopper has to sit
      // on the arrow itself. Re-bound on every open by stopArrowPointer(),
      // namespaced so re-binding replaces rather than stacks.
      $(document).on('click', '.cstm_next_arrow', function(event) {
        event.preventDefault();
        event.stopPropagation();
        window.__lightboxGo('next');
      });
      $(document).on('click', '.cstm_prev_arrow', function(event) {
        event.preventDefault();
        event.stopPropagation();
        window.__lightboxGo('prev');
      });
    }

    // Item 15: keep the thumbnail rail's first item on the selected variant.
    //
    // Dawn's product-info.js updateMedia() reads `media-gallery ul` — the FIRST
    // ul inside media-gallery, which is the slider. It adds, removes and sorts
    // items there and never touches the second ul, the thumbnail rail. Before
    // this item that was invisible: the rail carried every sibling's media, so
    // setActiveMedia always found the new variant's thumbnail already sitting
    // in it and merely moved it to the front. With the rail rendering the seven
    // items it actually displays, the new variant's thumbnail is not there, so
    // the first thumbnail kept showing whatever the page loaded with — measured
    // on the preview: slider first = 83000018-01-02-01.jpg while rail first =
    // 83000018.jpg, and no rail item matching the new slide's media id.
    //
    // The rail's first item IS the selected variant's thumbnail by construction
    // now, so it is repointed rather than inserted: same count, same order, and
    // clicking it calls setActiveMedia with an id the slider really has.
    //
    // Deliberately a no-op when the rail already holds a match — on an ordinary
    // product the rail is unpruned and Dawn's own prepend does this correctly,
    // and rewriting a thumbnail it was about to move would corrupt it.
    function syncRailToSelectedVariant() {
      var slide = document.querySelector('.product__media-list > li[data-media-id]');
      var rail = document.querySelector('.thumbnail-list');
      if (!slide || !rail) return;
      var id = slide.getAttribute('data-media-id');
      if (!id || rail.querySelector('[data-target="' + id + '"]')) return;
      var thumb = rail.querySelector('.thumbnail-list__item');
      var from = slide.querySelector('img');
      var to = thumb && thumb.querySelector('img');
      if (!thumb || !from || !to) return;
      var base = (from.getAttribute('src') || '').split('&width=')[0];
      if (!base) return;
      thumb.setAttribute('data-target', id);
      to.setAttribute('src', base + '&width=416');
      to.setAttribute('srcset', [54, 74, 104, 162, 208, 324, 416]
        .map(function (w) { return base + '&width=' + w + ' ' + w + 'w'; }).join(', '));
      if (from.getAttribute('alt')) to.setAttribute('alt', from.getAttribute('alt'));

      // Rebind the click, or the thumbnail asks for a medium that is gone.
      // media-gallery.js:19 binds each thumbnail with
      // `setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)` — the id
      // is captured AT BIND TIME, at page load, so repointing data-target does
      // not change what the listener sends. Clicking it then looked up an id the
      // rail no longer holds, and media-gallery.js:68 reads
      // `activeThumbnail.dataset.mediaPosition` with no null check, which throws.
      // Replacing the button drops Dawn's stale listener with the old node; the
      // fresh one reads data-target at click time, so it cannot go stale again.
      var button = thumb.querySelector('button');
      if (button && button.parentNode) {
        var rebound = button.cloneNode(true);
        button.parentNode.replaceChild(rebound, button);
        rebound.addEventListener('click', function () {
          var gallery = document.querySelector('media-gallery');
          var target = thumb.getAttribute('data-target');
          if (gallery && typeof gallery.setActiveMedia === 'function') {
            gallery.setActiveMedia(target, false);
          }
        });
      }

      // media-gallery.js now returns before setActiveThumbnail when the rail
      // has no thumbnail for the new medium — which is exactly the case this
      // function exists for — so aria-current would stay on whichever dot was
      // last highlighted. Move it here, where the thumbnail has just been made.
      if (slide.classList.contains('is-active')) {
        var gal = document.querySelector('media-gallery');
        if (gal && typeof gal.setActiveThumbnail === 'function') gal.setActiveThumbnail(thumb);
      }
    }

    // Item 15: keep the lightbox's contents on the media the gallery is showing.
    //
    // product-info.js refreshes the modal only on the same-product path
    // (handleUpdateProductInfo). A sibling swap — any Body Color change — calls
    // productModal?.remove() and expects the replacement <main> to bring its own,
    // but ModalDialog.connectedCallback moved the original to document.body at
    // first connect, so it is not inside <main> and does not go when <main> does.
    // The stale one survives. Measured on the preview: after a Body Color change
    // the slide and the zoom button both moved to media 38189059702935 while the
    // modal still held 38189181239447 — so the lightbox opened on the old
    // picture, and product-modal.js threw looking for a medium that is not there.
    //
    // Masked on main by the same 1,196 media that masked everything else in this
    // item: a modal holding every sibling's images always had whatever was asked
    // for, however stale it was.
    //
    // Rebuilt from the slider, which is always right, and rebuilt EAGERLY rather
    // than at click time: modal-opener binds Dawn's listener to the button
    // itself, so show() and showActiveMedia() run before any delegated handler
    // of ours could repair anything.
    function syncModalToSlider() {
      var modal = document.querySelector('product-modal');
      var content = document.querySelector('.product-media-modal__content');
      var slides = document.querySelectorAll('.product__media-list > li[data-media-id]');
      if (!modal || !content || !slides.length) return;
      if (modal.hasAttribute('open')) return;            // never rebuild under the customer
      var firstRaw = slides[0].getAttribute('data-media-id').split('-').pop();
      if (content.querySelector('[data-media-id="' + firstRaw + '"]')) return;   // already current

      // slick owns this element while the lightbox has been opened; replacing
      // innerHTML underneath it leaves its internal state pointing at nodes that
      // no longer exist.
      if (window.jQuery && $(content).hasClass('slick-initialized')) {
        $(content).slick('unslick');
      }

      var html = '';
      slides.forEach(function (slide) {
        var img = slide.querySelector('img');
        if (!img) return;
        var raw = slide.getAttribute('data-media-id').split('-').pop();
        var base = (img.getAttribute('src') || '').split('&width=')[0];
        if (!base) return;
        var alt = (img.getAttribute('alt') || '').replace(/"/g, '&quot;');
        html += '<img class="global-media-settings global-media-settings--no-shadow cstm_GPI"' +
                ' loading="lazy"' +
                ' data-media-id="' + raw + '"' +
                ' sizes="(min-width: 750px) calc(100vw - 22rem), 1100px"' +
                ' srcset="' + base + '&width=550 550w, ' + base + '&width=1445 1445w"' +
                ' src="' + base + '&width=1445"' +
                ' alt="' + alt + '">';
      });
      if (html) content.innerHTML = html;
    }

    // Body-level and debounced on purpose: a Body Color change replaces <main>
    // wholesale, so an observer bound to the gallery would go with it.
    var railSyncQueued = false;
    new MutationObserver(function () {
      if (railSyncQueued) return;
      railSyncQueued = true;
      setTimeout(function () {
        railSyncQueued = false;
        syncRailToSelectedVariant();
        syncModalToSlider();
      }, 120);
    }).observe(document.body, { childList: true, subtree: true });

    // Item 15: prime the lightbox's first image on hover.
    //
    // The modal's images are loading="lazy" and sit in a container that is not
    // displayed until the modal opens, so the browser starts fetching at click
    // time. The content box is only as tall as its image, which is why the
    // lightbox is a thin strip for a beat before the picture lands.
    //
    // Not `eager` in the markup: the modal's image is a DIFFERENT URL from the
    // gallery's — different `sizes` (calc(100vw - 22rem) against 715px) and a
    // different srcset — so it cannot come from the gallery's cache entry, and
    // making it eager would download a second full-size copy of the same photo
    // on every product page view for a lightbox most visitors never open.
    //
    // Hovering the gallery is the cheapest honest signal that somebody is about
    // to click it. `mouseover` rather than `pointerenter` because delegation
    // needs an event that bubbles.
    $(document).one('mouseover touchstart focusin', '.product-media-container', function () {
      var mediaId = $(this).find('.product__media-toggle').attr('data-media-id');
      if (!mediaId) return;
      var img = document.querySelector('.product-media-modal__content img[data-media-id="' + mediaId + '"]');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    });

    // Item 15. Delegated, not bound to the elements present at load.
    //
    // Changing Body Color swaps a sibling product in, and Dawn's product-info.js
    // replaces <main> wholesale and removes the modal on the way through
    // (handleSwapProduct). Direct bindings die with the nodes they were put on:
    // measured, the replacement .product__media-toggle came back with NO jQuery
    // handlers at all, so the lightbox opened with no carousel and the arrows
    // closed it. Pre-existing, and only reachable since image_zoom left "none".
    $(document).on('click', '.product__media-toggle', function(event) {
      event.preventDefault();
      // var getclickedThumbnailIndex = $(this).parent().parent().parent().parent().parent().next().find('.thumbnail-list__item.slider__slide .thumbnail[aria-current]').parent().index('.thumbnail-list > li:visible');
      var getclickedThumbnailIndex = $(this).attr('data-media-id');
      var $content = $('.product-media-modal__content');
      // Dawn closes the lightbox on Escape or a backdrop click WITHOUT the X
      // button, so the container can still say slick-initialized while its
      // track is gone (updateMedia replaced the innerHTML). slick 1.8 then
      // skips buildOut on the next init and hands back an instance with a null
      // slideCount, which goToNextAvailableSlide turned into a `% null` loop
      // that never exits. Review finding, 2026-09-08.
      if ($content.hasClass('slick-initialized')) {
        if ($content.find('.slick-track').length) {
          $content.slick('unslick');
        } else {
          $content.removeClass('slick-initialized slick-slider slick-dotted');
          $content.removeData('slick');
          if ($content[0]) $content[0].slick = undefined;
        }
      }
      $content.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        dots: false,
        autoplay: false,
        infinite: false,
        arrows: false,
        draggable: false,
        swipe: false
      });

      // Function to move to the next available slide with 'active' or 'cstm_GPI' class
      function goToNextAvailableSlide(direction) {
          var $slickSlider = $('.product-media-modal__content');
          var currentSlide = $slickSlider.slick('slickCurrentSlide');
          var totalSlides = $slickSlider.slick('getSlick').slideCount;
          if (!totalSlides) return;   // a hollow instance: nothing to walk
          
          // Define the variable to track the next slide
          var nextSlide = currentSlide;
          
          // Loop to find the next or previous slide with the class
          do {
              // Increment or decrement slide index based on direction
              nextSlide = direction === 'next' ? (nextSlide + 1) % totalSlides : (nextSlide - 1 + totalSlides) % totalSlides;
              
              // Check if the next/previous slide has the required classes
              var $nextSlide = $slickSlider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
              var hasClass = $nextSlide.hasClass('active') || $nextSlide.hasClass('cstm_GPI');
              
              if (hasClass) {
                  // If the slide has the required class, move to it
                  $slickSlider.slick('slickGoTo', nextSlide);
                  return;
              }
              
              // Exit condition: If we've looped all the way around and come back to the current slide, stop
          } while (nextSlide !== currentSlide);
      }
      
      // The arrow handlers are bound once, outside this one, by
      // bindLightboxArrows() below — binding them in here would stack a fresh
      // copy on every open.
      bindLightboxArrows(goToNextAvailableSlide);
      stopArrowPointer();

      var moveSlickSlide = $(`.product-media-modal__content .global-media-settings[data-media-id="${getclickedThumbnailIndex}"]`).attr('data-slick-index');
      $('.product-media-modal__content').slick('slickGoTo', moveSlickSlide);

      // // Function to click the custom next arrow with a delay
      // function clickArrowWithDelay(times, delay) {
      //   for (let i = 0; i < times; i++) {
      //     setTimeout(function() {
      //       $('.cstm_next_arrow').click(); // Simulate the click using jQuery
      //     }, i * delay); // Delay between each click
      //   }
      // }
      
      // if(getclickedThumbnailIndex > 1) {
      //   clickArrowWithDelay(getclickedThumbnailIndex, 800);
      // }
      
    });

    $(document).on('click', '.product-media-modal__toggle', function(event) {
      event.preventDefault();
      $('.product-media-modal').attr('open', false);
      $('.product-media-modal__content').slick('unslick');
    });
    // The X button is not the only way out: Dawn's ModalDialog.hide() fires
    // this on Escape and on a backdrop click (global.js). Same teardown.
    document.body.addEventListener('modalClosed', function () {
      // Dawn fires this BEFORE it removes `open`, so the check has to wait a
      // tick or it always sees an open modal and does nothing.
      setTimeout(function () {
        if (document.querySelector('product-modal[open]')) return;
        var $c = $('.product-media-modal__content');
        if ($c.hasClass('slick-initialized') && $c.find('.slick-track').length) $c.slick('unslick');
      }, 0);
    });

    // $('.cstm_zoom_in').click(function(event) {
    //     event.preventDefault();
    //     $('.product__media-list .product__media-item .product__media img').addClass('zoom-active');
    //     $(this).attr('style', 'display: none !important;');
    //     $('.cstm_zoom_out').attr('style', 'display: block !important;');
      
    //     let isDragging = false;
    //     let startX, startY, translateX = 0, translateY = 0;
    
    //     function startDrag(e) {
    //         isDragging = true;
    
    //         // Handle touch events
    //         if (e.type === 'touchstart') {
    //             startX = e.touches[0].pageX;
    //             startY = e.touches[0].pageY;
    //         } else {
    //             startX = e.pageX;
    //             startY = e.pageY;
    //         }
    
    //         // Prevent image selection while dragging
    //         e.preventDefault();
    //     }
    
    //     function drag(e) {
    //         if (!isDragging) return;
    
    //         let moveX, moveY;
    
    //         if (e.type === 'touchmove') {
    //             moveX = e.touches[0].pageX - startX;
    //             moveY = e.touches[0].pageY - startY;
    //         } else {
    //             moveX = e.pageX - startX;
    //             moveY = e.pageY - startY;
    //         }
    
    //         translateX += moveX;
    //         translateY += moveY;
    
    //         $('.product__media-list .product__media-item .product__media img.zoom-active').css({
    //             'transform': `translateX(-50%) translateY(-50%) translate(${translateX}px, ${translateY}px)`
    //         });
    
    //         startX += moveX;
    //         startY += moveY;
    //     }
    
    //     function endDrag() {
    //         isDragging = false;
    //     }
    
    //     // Start dragging on mouse down or touch start
    //     $('.product__media-list .product__media-item .product__media img.zoom-active').on('mousedown touchstart', startDrag);
    
    //     // Handle dragging movement on mouse move or touch move
    //     $(document).on('mousemove touchmove', drag);
    
    //     // Stop dragging on mouse up or touch end
    //     $(document).on('mouseup touchend', endDrag);
    // });





    // $('.cstm_zoom_out').click(function(event) {
    //   event.preventDefault();
    //   $('.product__media-list .product__media-item .product__media img').removeClass('zoom-active');
    //   $(this).attr('style', 'display: none !important;');
    //   $('.cstm_zoom_in').attr('style', 'display: block !important;');
    // });

    // Item 165, 2026-10-30. Notify Me posts to SYS-OOS, the back-in-stock
    // service, through the shop's App Proxy: a same-origin POST to
    // /apps/sys-oos/notify that Shopify signs and forwards to Windmill. Nothing
    // here is a secret. The form it submits is in main-product.liquid, inside
    // the same .product-popups modal shell the old form used.
    //
    // What this replaced: a click handler that opened Globo form 86833 and, on
    // every click, bound one more submit handler on Globo's button that posted
    // a back-in-stock subscription straight to Klaviyo's client API (item 142,
    // defect 5). Both paths are gone on purpose -- SYS-OOS owns the Klaviyo
    // side now. Globo stays installed for the contact, Partners and Project
    // Orders forms.
    //
    // DAWN 16 MERGE NOTE: Odyssey's dawn-16-upgrade branch (5fdefa0, "Fix
    // Klaviyo back-in-stock subscriptions") patches the handler this replaced.
    // When that branch is merged this block conflicts; keep THIS side whole and
    // drop theirs. Do not reintroduce the a.klaviyo.com post.
    //
    // Response table (server always answers HTTP 200 with JSON):
    //   ok:true, any status            -> thanks
    //   ok:false, error bad_email      -> check the address
    //   ok:false, error in_stock       -> good news; re-run the availability toggle
    //   ok:false, anything else        -> generic (ids wrong = a theme bug, logged)
    //   network error / non-JSON       -> generic, keep the fields filled
    var SYS_OOS_ENDPOINT = '/apps/sys-oos/notify';
    var SYS_OOS_MESSAGES = {
      thanks: "Thanks \u2014 we'll email you when it's back.",
      bad_email: 'Please check the email address.',
      in_stock: "Good news \u2014 this is in stock.",
      generic: 'Something went wrong, please try again.'
    };
    // Every lookup happens at call time and every handler is delegated to the
    // document. On a SellersDash parent, choosing a sibling's color makes Dawn
    // 15 replace the whole <product-info> element (handleSwapProduct in
    // product-info.js), and the button, the form and the close control all live
    // inside it: a handler bound to the elements present at load dies with
    // them. The old Globo wiring had that flaw -- Notify Me went dead after a
    // sibling swap. Delegation survives the swap, and the re-rendered form
    // carries the new product id.
    function oosOverlay() { return $('.product-popups'); }
    function oosDialog() { return $('.product-popup'); }
    function oosForm() { return $('.sys-oos-form'); }

    function oosStatus($form, text, kind) {
      $form.find('.sys-oos-form__status')
        .text(text)
        .removeClass('is-error is-success')
        .addClass(kind ? 'is-' + kind : '');
    }

    function oosReset($form) {
      if (!$form.length) return;
      $form[0].reset();
      $form.removeClass('is-busy is-done');
      $form.find('.sys-oos-form__submit').prop('disabled', false);
      oosStatus($form, '', null);
    }

    function oosOpen() {
      var $form = oosForm();
      oosReset($form);
      oosOverlay().addClass('active');
      oosDialog().addClass('active');
      $form.find('input[name="email"]').trigger('focus');
    }

    function oosClose() {
      oosOverlay().removeClass('active');
      oosDialog().removeClass('active');
      oosReset(oosForm());
      $('.cstm_notify_me').trigger('focus');
    }

    // The selected variant's ids. resolveVariant() reads the variant object Dawn
    // renders in <script data-selected-variant>; the hidden form input is the
    // fallback for the variant id. The product id comes from the form's
    // data-product-id, which Liquid renders as gallery_selected_variant.product.id
    // -- the OWNING product, which on a SellersDash parent is a sibling and not
    // this page's product (measured 2026-10-30: `variant | json` carries no
    // product_id, so the variant object cannot supply it; the check for one is
    // kept in case a later Dawn adds it). When neither knows, product_id is
    // omitted rather than guessed: the server treats it as a cross-check.
    function oosSelectedIds($form) {
      var variant = resolveVariant();
      var hiddenId = $('.custom_btn_buy form .product-variant-id').val();
      return {
        variant_id: String((variant && variant.id) || hiddenId || ''),
        product_id: String((variant && variant.product_id) || $form.attr('data-product-id') || '')
      };
    }

    $(document).on('click', '.cstm_notify_me', function (event) {
      event.preventDefault();
      oosOpen();
    });

    $(document).on('click', '.exit-svg-popup', function () { oosClose(); });

    // The dimmed backdrop is .product-popups::before; a click on a pseudo-element
    // targets its owner, so a click on the overlay itself (not the dialog) closes.
    $(document).on('click', '.product-popups', function (event) {
      if (event.target === this) oosClose();
    });

    $(document).on('keydown', function (event) {
      if (event.key === 'Escape' && oosOverlay().hasClass('active')) oosClose();
    });

    $(document).on('submit', '.sys-oos-form', function (event) {
      event.preventDefault();
      var $form = $(this);
      if ($form.hasClass('is-busy') || $form.hasClass('is-done')) return;

      var emailInput = $form.find('input[name="email"]')[0];
      var email = $.trim(emailInput.value);
      if (!email || !emailInput.checkValidity()) {
        oosStatus($form, SYS_OOS_MESSAGES.bad_email, 'error');
        emailInput.focus();
        return;
      }

      var ids = oosSelectedIds($form);
      if (!ids.variant_id) {
        console.error('SYS-OOS: no selected variant id on the page');
        oosStatus($form, SYS_OOS_MESSAGES.generic, 'error');
        return;
      }

      var payload = {
        email: email,
        variant_id: ids.variant_id,
        first_name: $.trim($form.find('input[name="first_name"]').val() || '').slice(0, 80),
        newsletter: $form.find('input[name="newsletter"]').is(':checked'),
        page_url: window.location.href,
        website: $form.find('input[name="website"]').val() || ''
      };
      if (ids.product_id) payload.product_id = ids.product_id;

      var $submit = $form.find('.sys-oos-form__submit');
      $form.addClass('is-busy');
      $submit.prop('disabled', true);
      oosStatus($form, '', null);

      fetch(SYS_OOS_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) { return response.json(); })
        .then(function (body) {
          if (body && body.ok === true) {
            $form.addClass('is-done');
            oosStatus($form, SYS_OOS_MESSAGES.thanks, 'success');
            return;
          }
          var error = body && body.error;
          if (error === 'bad_email') {
            oosStatus($form, SYS_OOS_MESSAGES.bad_email, 'error');
            emailInput.focus();
          } else if (error === 'in_stock') {
            // The toggle hid Add to cart on stale availability; let it re-decide.
            $form.addClass('is-done');
            oosStatus($form, SYS_OOS_MESSAGES.in_stock, 'success');
            checkDisabledOptions();
          } else {
            if (error === 'unknown_variant' || error === 'product_mismatch' || error === 'bad_variant') {
              console.error('SYS-OOS: the theme sent ids the server rejected (theme bug)', payload, body);
            } else {
              console.error('SYS-OOS: unexpected response', body);
            }
            oosStatus($form, SYS_OOS_MESSAGES.generic, 'error');
          }
        })
        .catch(function (err) {
          console.error('SYS-OOS: notify request failed', err);
          oosStatus($form, SYS_OOS_MESSAGES.generic, 'error');
        })
        .then(function () {
          $form.removeClass('is-busy');
          if (!$form.hasClass('is-done')) $submit.prop('disabled', false);
        });
    });

    // Item 15 (B), 2026-09-08. The vendor's mobile gallery code that lived here
    // (~330 lines: a per-<li> touchstart/touchend swipe handler that reordered
    // the cstm_GPI slides and force-scrolled by a hardcoded 377px stride, plus
    // an iPhone-only "alignment" pass that rewrote scrollLeft 150ms after every
    // scroll) is gone, together with `touch-action: pan-y` in twd.css. It was
    // written to keep the visible slides contiguous inside a scroll-snap
    // container full of hidden ones; the gallery no longer renders hidden
    // slides, so Dawn's own .slider--mobile scroll-snap does the swiping.
    //
    // It had to go rather than be repaired: the handlers were bound once at
    // load to the <li>s present then, and Dawn creates the new variant's <li>
    // fresh on a swatch change, so the slide the customer landed on had no
    // handler and native panning was disabled — the gallery froze.
    
  }   

  $('.cstm_featured_coll .quick-add button').click(function(e) {
    e.preventDefault();
    var proURL = $(this).parent().parent().parent().parent().find('a').attr('href');
    window.location.href = proURL;
  });

  var relatedProdSlider = $('.cstm-related-products .grid').slick({
    infinite: false,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  // Item 141, 2026-09-09. Forty lines lived here that, on every product page
  // with no ?variant=, clicked the FIRST radio of every option 500ms apart —
  // a Dawn 13 shim for a page that did not know its variant at load. Liquid
  // now resolves the variant server-side and marks the radio checked, so all
  // the shim could do was move a correct selection: measured on
  // /products/stack-sys3-l, it took a purchasable page to "Sold out" 3.5s
  // after load. Its ?variant= branch had been dead since the Dawn 15 cutover.

  // $('.cstm_var_sel_wrapper').removeClass('cstm_notAvailable');

});


  function customizeClick(element, event) {
    event.preventDefault();
  
    // Hide the clicked button
    element.style.display = 'none';
  
    // Show the next sibling element
    var nextSibling = element.nextElementSibling;
    if (nextSibling) {
        nextSibling.style.display = 'block';
    }

    var clickIndex = element.getAttribute('data-index');
    if(document.querySelector(`.cstm_related_prod_variants_wrapeper[data-index="${clickIndex}"]`)) {
      document.querySelector(`.cstm_related_prod_variants_wrapeper[data-index="${clickIndex}"]`).style.display = 'flex';
    }
  
    // // Get the current slide index of the related product slider
    // var currentSlideIndex = relatedProdSlider.slick('slickCurrentSlide');
  
    // // Move the slider to the current slide index
    // relatedProdSlider.slick('slickGoTo', currentSlideIndex);
  }

  // Inline function for handling select change
  function updateVariant(selectElement, event) {
      // Prevent the change event from bubbling up to Dawn's global cart listeners
      if (event) {
          event.stopPropagation();
      }

      var clickIndex = selectElement.getAttribute('data-index');
      var selectElements = document.querySelectorAll(`.cstm_related_prod_variants_wrapeper[data-index="${clickIndex}"] .cstm_related_prod_variants_inner select`);
      var valuesArray = [];
      
      // Loop through the NodeList and collect the values
      selectElements.forEach(function(selectElement) {
          valuesArray.push(selectElement.value);
      });
      
      // Concatenate the values with " / " separator
      var concatenatedValues = valuesArray.join(' / ');

      var options = document.querySelectorAll(`.cstm_recommended_accessories_variants[data-index="${clickIndex}"] option`);

      options.forEach(function(option) {
        if (option.textContent === concatenatedValues) {
            option.selected = true;
        } else {
            option.selected = false;
        }
      });

      // Get the dropdown element
      var dropdownSelected = document.querySelector(`.cstm_recommended_accessories_variants[data-index="${clickIndex}"]`);
      
      // Get the selected option
      var selectedOption = dropdownSelected.options[dropdownSelected.selectedIndex];
      
      // Check if the selected option is disabled
      if (selectedOption.disabled) {
          var errorDiv = document.createElement('div');
          errorDiv.className = 'cstm_error';
          errorDiv.textContent = 'This variant option is out of stock. Please select another one.';
          var cardWrapper = document.querySelector(`.card-wrapper[data-index="${clickIndex}"]`);
          if (!cardWrapper.querySelector('.cstm_error')) {
              cardWrapper.appendChild(errorDiv);
          }
      } else {
          const errorEl = document.querySelector(
            `.card-wrapper[data-index="${clickIndex}"] .cstm_error`
          );

          if (errorEl) {
            errorEl.remove();
          }

          var selectedVal = document.querySelector(`.cstm_recommended_accessories_variants[data-index="${clickIndex}"]`).value;
          document.querySelector(`.cstm_add_cart[data-index="${clickIndex}"]`).setAttribute('data-variant-id', selectedVal);
      }
  }
  
  // Inline function for handling button click
  function addToCart(buttonElement, event) {
    event.preventDefault();
      var varID = buttonElement.getAttribute('data-variant-id');
      var data = {
          "id": varID,
          "quantity": 1
      };
  
      jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function(response) { 
              fetch(`${routes.cart_url}?section_id=cart-drawer`)
                  .then((response) => response.text())
                  .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                      for (const selector of selectors) {
                          const targetElement = document.querySelector(selector);
                          const sourceElement = html.querySelector(selector);
                          if (targetElement && sourceElement) {
                              targetElement.replaceWith(sourceElement);
                          }
                      }
                      // If needed, reinitialize additional JS
                          var relatedProdSlider = $('.cstm-related-products .grid').slick({
                          infinite: false,
                          dots: true,
                          arrows: false,
                          adaptiveHeight: true,
                          slidesToShow: 1,
                          slidesToScroll: 1
                        });
                      relatedProdSlider.slick('refresh');
                  })
                  .catch((e) => {
                      console.error(e);
                  });
          }
      });
  }

  function soldOut(element, event) {
    event.preventDefault();
  }




document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll('.video-card');
  const modal = document.getElementById('video-modal');
  const closeBtn = document.querySelector('.modal-close');
  const modalTitle = document.getElementById('modal-title');
  const youtubePlayer = document.getElementById('youtube-video-player');
  const shopifyPlayer = document.getElementById('shopify-video-player');
  const modalDescription = document.getElementById('modal-description');
  const modalProductsGrid = document.getElementById('modal-products-grid');

  // Function to load product cards
  async function loadProductCards(productIds) {
    if (!productIds || productIds.length === 0 || !modalProductsGrid) return;
    
    try {
      const response = await fetch(`/products.json?ids=${productIds.join(',')}`);
      const { products } = await response.json();
      
      modalProductsGrid.innerHTML = '';
      
      products.forEach(product => {
        const productCard = document.createElement('li');
        productCard.className = 'grid__item';
        
        const firstVariant = product.variants[0];
        const price = Shopify.formatMoney(firstVariant.price, '{{ shop.money_format }}');
        
        productCard.innerHTML = `
          <div class="modal-product-card">
            <a href="${product.url}">
              <img src="${product.images[0]?.src || '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large.gif'}" 
                  alt="${product.title}" 
                  class="modal-product-image"
                  loading="lazy">
            </a>
            <div class="modal-product-info">
              <h3 class="modal-product-title">
                <a href="${product.url}">${product.title}</a>
              </h3>
              <div class="modal-product-price">${price}</div>
            </div>
          </div>
        `;
        
        modalProductsGrid.appendChild(productCard);
      });
    } catch (error) {
      console.error('Error loading products:', error);
    }
  }

  cards.forEach(card => {
    card.addEventListener('click', () => {
      if (!modal || !modalTitle || !modalDescription) return;
      
      const title = card.getAttribute('data-title');
      const videoType = card.getAttribute('data-video-type');
      const videoUrl = card.getAttribute('data-video');
      const shopifyVideoUrl = card.getAttribute('data-shopify-video');
      const desc = card.getAttribute('data-description');
      const relatedProducts = card.getAttribute('data-related-products')?.split(',').filter(Boolean) || [];

      modalTitle.textContent = title;
      modalDescription.innerHTML = desc;

      // Hide both players first
      if (youtubePlayer) youtubePlayer.style.display = 'none';
      if (shopifyPlayer) shopifyPlayer.style.display = 'none';

      if (videoType === 'shopify' && shopifyVideoUrl && shopifyPlayer) {
        // Play Shopify video
        shopifyPlayer.src = shopifyVideoUrl;
        shopifyPlayer.style.display = 'block';
        shopifyPlayer.play();
      } else if (videoUrl && youtubePlayer) {
        // Play YouTube video
        const youtubeEmbedUrl = videoUrl.includes('youtube.com') 
          ? videoUrl.replace("watch?v=", "embed/").replace("youtu.be/", "youtube.com/embed/")
          : `https://www.youtube.com/embed/${videoUrl.split('v=')[1]}`;
        youtubePlayer.src = youtubeEmbedUrl;
        youtubePlayer.style.display = 'block';
      }

      // Load related products
      if (modalProductsGrid) {
        if (relatedProducts.length > 0) {
          loadProductCards(relatedProducts);
        } else {
          modalProductsGrid.innerHTML = '<p>No related products found</p>';
        }
      }

      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      if (!modal) return;
      
      modal.classList.remove('active');
      if (youtubePlayer) youtubePlayer.src = '';
      if (shopifyPlayer) shopifyPlayer.src = '';
      document.body.style.overflow = 'auto';
      
      // Pause the video when closing
      if (shopifyPlayer && shopifyPlayer.style.display === 'block') {
        shopifyPlayer.pause();
      }
    });
  }

  // Close modal when clicking outside content
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal && closeBtn) {
        closeBtn.click();
      }
    });
  }










//  if (document.querySelector('.search-bar')) {
//   document.querySelector('.search-bar').addEventListener('input', function (event) {
//     event.preventDefault();
//     let query = this.value.toLowerCase().trim(); // Search query
//     let sections = document.querySelectorAll('.video-grid'); // All sections

//     // If query is empty, show all sections/products and remove 'grid-ps' class
//     if (query === "") {
//       sections.forEach(function (section) {
//         section.style.display = 'grid';
//         section.classList.remove('grid-ps'); // 🔴 Remove class when input is empty

//         let products = section.querySelectorAll('.video-card');
//         products.forEach(function (product) {
//           product.style.display = 'grid';
//         });
//       });
//       return; // Stop further execution
//     }

//     // If query is not empty, do filtering and add 'grid-ps' class
//     sections.forEach(function (section) {
//       let products = section.querySelectorAll('.video-card');
//       let hasVisibleProduct = false;

//       products.forEach(function (product) {
//         let productName = product.querySelector('.video-card-title').textContent.toLowerCase();

//         if (productName.includes(query)) {
//           product.style.display = 'grid';
//           hasVisibleProduct = true;
//         } else {
//           product.style.display = 'none';
//         }
//       });

//       if (hasVisibleProduct) {
//         section.style.display = 'grid';
//         section.classList.add('grid-ps'); // ✅ Add class when matches found
//       } else {
//         section.style.display = 'none';
//         section.classList.remove('grid-ps'); // ❌ Remove class when no match
//       }
//     });
//   });
// }










  

  
  
});




$(function () {
    const $compatibleWidthSec = $('.cstm_compatible_coll_sec .quick-add product-form');

    if ($compatibleWidthSec.length) {
      $compatibleWidthSec.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const variantId = $(this).find('button[type="submit"]').data('variant-id');
        if (!variantId) {
          console.error('No data-variant-id found on button');
          return;
        }

        const data = {
          id: variantId,
          quantity: 1
        };

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function (response) {

            fetch(`${routes.cart_url}?sections=cart-drawer`)
            .then((response) => response.json())
            .then((sections) => {
              const sectionIds = ['cart-drawer'];
              for (const sectionId of sectionIds) {
                const htmlString = sections[sectionId];
                const html = new DOMParser().parseFromString(htmlString, 'text/html');
                const sourceElement = html.querySelector(`${sectionId}`);
                const targetElement = document.querySelector(`${sectionId}`);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
              }
              document.body.classList.add('overflow-hidden');
              const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
              theme_cart.classList.add('active');
              theme_cart.classList.add('animate');

              const $relatedProdSlider = $('.cstm-related-products .grid');
              if ($relatedProdSlider.hasClass('slick-initialized')) {
                $relatedProdSlider.slick('unslick');
              }

              $relatedProdSlider.slick({
                infinite: false,
                dots: true,
                arrows: false,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }).slick('refresh');

            })
            .catch((e) => {
              console.error('Error updating cart sections:', e);
            });
          },
          error: function (xhr, status, error) {
            console.error('Error adding to cart:', error);
          }
        });
      });
    }
});